import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { IconTab } from "@/src/components/iconTab";
import { Hospitalisation, Patient, TemporaryLeave } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId } from "@/src/utils/utils";
import moment from "moment";
import { RiFolderTransferLine } from "react-icons/ri";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import { TemporaryLeaveForm } from "../temporaryLeaveForm";
import { CgArrowsExchange } from "react-icons/cg";

export default function TemporaryLeaveButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: TemporaryLeave) => void;
}) {
  async function openTemporaryLeaveForm(temporaryLeave: TemporaryLeave) {
    await openDrawer({
      id: "temporaryLeaveDrawer",
      title: "Autorisation de sortie",
      content: (
        <TemporaryLeaveForm
          temporaryLeave={temporaryLeave}
          onChange={(newValue) => {
            temporaryLeave = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        let result = await apiFetch("temporaryLeaves", "addOne", {
          temporaryLeave,
        });
        if (!result) return;
        parent.temporaryLeave = result;
        await apiFetch(
          "hospitalisations",
          "addOne",
          {
            hospitalisation: {
              id: getItemId(parent),
              type: "hospitalisation",
              temporaryLeave: result,
            },
          },
          "Erreur lors de l'enregistrement de l'hospitalisation"
        );
        closeDrawer("sortieTypeDrawer");
        onSave(result);
      },
    });
  }
  return (
    <IconTab
      id={"temporaryLeave"}
      activeTabId={null}
      isHorizontal={true}
      name={"Permission de sortie"}
      icon={<CgArrowsExchange size={25} />}
      onChange={async () => {
        let temporaryLeave: TemporaryLeave = {
          type: "temporaryLeave",
          exitDate: moment().format("YYYY-MM-DD"),

          returnDate: null,
          status: "validated",
          notes: "",
          creator: getUserId(),
          patient,
          parent: getItemId(parent),
          confidentiality: getStandardConfidentiality(patient),
          readBy: [getUserId()],
        };

        await openTemporaryLeaveForm(temporaryLeave);
      }}
    />
  );
}
